<template>
  <div>
    <HistoryInfoBoxes :detail="info">
      <template #box0>
        <v-row no-gutters>
          <v-col cols="1">{{
            $t('loading.loading_target-order-number') + ':'
          }}</v-col>
          <v-col class="ml-1"
            >{{ items.order.transaction.controlNumber }}
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="1">{{ $t('loading.loading_loading-number') }}</v-col>
          <v-col class="ml-1">{{ items.transaction.controlNumber }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="1"> {{ $t('common.input_remarks') + ':' }} </v-col>
          <v-col class="ml-1"
            >{{ items.loadingNote ? items.loadingNote.body : '' }}
          </v-col>
        </v-row>
      </template>
    </HistoryInfoBoxes>
  </div>
</template>
<script>
import HistoryInfoBoxes from '@/components/items/Designs/HistoryInfoBoxes'
export default {
  components: { HistoryInfoBoxes },
  props: {
    items: { default: {} }
  },
  data: () => ({
    info: []
  }),
  created() {
    this.info = this.createList()
  },
  methods: {
    createList() {
      const loadingInfo = {
        ...this.interfaceObj,
        title: 'loading.loading_loading-info'
      }

      return [loadingInfo]
    }
  },
  computed: {}
}
</script>
<style lang="scss" scoped></style>
